
import React from "react";

import ConceptLumina from "../../components/ConceptProjects/ConceptLumina";
import ConceptPuertaDelSol from "../../components/ConceptProjects/ConceptPuertaDelSol";
import ConceptTorreTexao from "../../components/ConceptProjects/ConceptTorreTexao";
import ConceptViaMaria from "../../components/ConceptProjects/ConcepViaMaria";
import ConceptIkiga from "../../components/ConceptProjects/ConceptIkiga";
import ConceptIdilioVistania from "../../components/ConceptProjects/ConceptIdilioVistania";
import LateralNavProjects from "../../components/LateralNavProjects/LateralNavProjects";

class ConceptProjectPage extends React.Component<any, any> {
  componentDidMount() {
    const path = window.location.pathname.split("/")[2];
    const pathNameProject = window.location.pathname.split("/").length > 3;
    const project = window.location.pathname.includes("/proyectos");
    const concept = window.location.pathname.includes("/concept");
    const coverProject = document.getElementById("cover");
    const bg = document.getElementById("img-background");
    const btn = document.getElementById("btn-iso");
    if (coverProject && project) {
      coverProject.classList.add(`cover-two`);
    }
    if (bg) {
      bg.classList.add(`${path}-cover`);
      if(pathNameProject){
        bg.classList.add("blur");
      }
    }
    if (concept && coverProject) {
      coverProject.classList.add(`cover-three`);
    }
    if (btn) {
      btn.style.display = "none";
    }
  }
  
  render() {
    return (
      <div className="wraper wraper-two">
        <div className="item left">
          <LateralNavProjects />
        </div>
        <div className="item right">
          <div className="right__cont">
            {window.location.pathname.includes("/lumina") ?
              <ConceptLumina />
              : window.location.pathname.includes("/via-maria") ?
                <ConceptViaMaria />
                : window.location.pathname.includes("/torre-texao") ?
                  <ConceptTorreTexao />
                  : window.location.pathname.includes("/puerta-del-sol") ?
                    <ConceptPuertaDelSol />
                    : window.location.pathname.includes("/ikiga") ?
                      <ConceptIkiga />
                      : window.location.pathname.includes("/idilio-vistania") ?
                        <ConceptIdilioVistania />: ""
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ConceptProjectPage;